import React from 'react';

import NumberWidgetBarSettings from './NumberWidgetBarSettings';
import NumberWidgetCircularSettings from './NumberWidgetCircularSettings';
import NumberWidgetSettings from './NumberWidgetSettings';
import ColumnChartWidgetSettings from './ColumnChartWidgetSettings';
import './DisplaySettings.scss';

function DisplaySettings(props) {
    const displaySettings = {
        NumberWidgetBar: NumberWidgetBarSettings,
        NumberWidgetCircular: NumberWidgetCircularSettings,
        NumberWidget: NumberWidgetSettings,
        ColumnChartWidget: ColumnChartWidgetSettings,
        ColumnTableWidget: NumberWidgetBarSettings
    };

    const ThisSettings = displaySettings[props.widget.displayType];
    if (ThisSettings && _.includes(['sales', 'opportunities', 'activities', 'meetings','saleCall'], props.widget.widgetType)) {
        return (
            <div className="displaySettings">
                <div className="setting">
                    <ThisSettings {...props} />
                </div>
            </div>
        );
    }

    return null;
}

DisplaySettings.propTypes = {
    widget: React.PropTypes.object,
};

export default DisplaySettings;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DisplaySettings/DisplaySettings.jsx
 **/